import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";

function ScoreDisplay({ momentNum, score, text, deleteTodayKey }) {
  const visibility =
    score || text
      ? { width: "36px", opacity: 1 }
      : { width: "auto", opacity: 0.5 };

  return (
    <div
      className="scoreWrapper"
      style={{
        width: `${visibility.width}`,
        opacity: `${visibility.opacity}`,
      }}
    >
      <strong style={{ color: "#e2dfcf" }}>{score ? score : ""}</strong>

      <FontAwesomeIcon
        icon={faTrash}
        className="day__icon--trash"
        data-name={`moment${momentNum}`}
        onClick={(e) => {
          deleteTodayKey(e);
        }}
        style={{ color: "#e2dfcf" }}
        size="sm"
      />
    </div>
  );
}

export default ScoreDisplay;
